// CalendlyWidget.jsx
import React, { useEffect, useState } from 'react';

const CalendlyWidget = ({
  buttonText = "Schedule Consultation",
  buttonClassName = "",
  calendlyUrl = "https://calendly.com/shutterlifters/30min"
}) => {
  const [isCalendlyLoaded, setIsCalendlyLoaded] = useState(false);

  useEffect(() => {
    // Check if Calendly is already loaded
    if (window.Calendly) {
      setIsCalendlyLoaded(true);
      return;
    }

    // Add Calendly CSS only if not already present
    if (!document.getElementById("calendly-css")) {
      const link = document.createElement("link");
      link.href = "https://assets.calendly.com/assets/external/widget.css";
      link.rel = "stylesheet";
      link.id = "calendly-css";
      document.head.appendChild(link);
    }

    // Add Calendly JS only if not already present
    if (!document.getElementById("calendly-script")) {
      const script = document.createElement("script");
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      script.id = "calendly-script";
      script.onload = () => {
        setIsCalendlyLoaded(true);
      };
      document.body.appendChild(script);
    }

    // Don't cleanup - keep Calendly loaded for the entire session
  }, []);

  const handleClick = () => {
    if (window.Calendly && isCalendlyLoaded) {
      window.Calendly.initPopupWidget({
        url: calendlyUrl
      });
    } else {
      console.log("Calendly is still loading...");
    }
  };

  return (
    <button
      onClick={handleClick}
      className={buttonClassName}
      disabled={!isCalendlyLoaded}
    >
      {buttonText}
    </button>
  );
};

export default CalendlyWidget;